import { useState } from 'react'
import { Box, Button, HStack, Input, Text, VStack } from '@chakra-ui/react'
import { useCreateScript } from '../../../hooks/useScript'
import { extractApiMessage } from '../../../lib/apiError'

/** [O4] "+ New script…": a name only, created blank through the normal script-create path and
 *  hooked to the stop at once, so the organizer never leaves the map. */
export function NewScriptStub({ onCreated, onCancel }: {
  onCreated: (scriptId: string, label: string) => void
  onCancel: () => void
}) {
  const [name, setName] = useState('')
  const [error, setError] = useState<unknown>(null)
  const { mutateAsync: createScript, isPending } = useCreateScript()
  const label = name.trim()

  const create = async () => {
    if (!label) return
    setError(null)
    try {
      const script = await createScript({ label, elements: [], resultSettings: [] })
      onCreated(script.id, label)
    } catch (err) {
      setError(err)
    }
  }

  return (
    <Box borderWidth="1px" borderColor="border" borderRadius="md" p={3}>
      <VStack align="stretch" gap={2}>
        <Text fontSize="xs" fontWeight="medium" color="fg.muted" textTransform="uppercase">New script</Text>
        <Input
          size="sm"
          aria-label="Script name"
          placeholder="Script name"
          minH={{ base: '44px', md: 'auto' }}
          value={name}
          required
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') void create() }}
        />
        <Text fontSize="xs" color="fg.muted">
          Fill it in from Scripts any time before the canvasser reaches this stop.
        </Text>
        {!!error && <Text fontSize="sm" color="danger.fg">{extractApiMessage(error, 'Could not create the script')}</Text>}
        <HStack justify="flex-end" gap={2}>
          <Button size="sm" variant="ghost" minH={{ base: '44px', md: 'auto' }} onClick={onCancel}>Cancel</Button>
          <Button size="sm" colorPalette="brand" minH={{ base: '44px', md: 'auto' }}
            disabled={!label} loading={isPending} onClick={() => void create()}>
            Create &amp; use
          </Button>
        </HStack>
      </VStack>
    </Box>
  )
}
